<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijbewijs DE halen?</h1>
      <p>
        Ben je bevoegd om achter het stuur van een bus te kruipen, maar wil je
        ook graag het rijbewijs DE in de wacht slepen om een bus met aanhanger
        te kunnen besturen, bijvoorbeeld als chauffeur naar
        vakantiebestemmingen? Dan zit je goed op Rijscholenvergelijker.nl. Wij
        bieden je de mogelijkheid om, geheel kosteloos en zonder ergens aan vast
        te zitten, informatie aan te vragen bij verschillende rijscholen bij jou
        in de omgeving. Je hoeft alleen maar je belangrijkste persoonlijke
        gegevens achter te laten en aan te geven dat het om het rijbewijs DE
        gaat en wij zorgen ervoor dat de rijscholen in jouw regio binnen 24 uur
        contact opnemen.
      </p>

      <h2>Rijbewijs DE</h2>
      <p>
        Het rijbewijs DE is bijvoorbeeld geschikt voor buschauffeurs die
        vakantiegangers naar hun bestemming brengen en extra laadruimte bij hun
        touringcar nodig hebben. Is het niet langer dan drie jaar geleden dat je
        je D-rijbewijs hebt behaald? Dan hoef je voor het rijbewijs DE geen
        nieuwe medische keuring te ondergaan en heb je alleen een Eigen
        Verklaring nodig. Ben je benieuwd naar de kosten? Via
        Rijscholenvergelijker.nl krijg je gratis inzicht in onder andere de
        tarieven van de verschillende rijscholen in de omgeving.
      </p>

      <h2>Bespaar euro’s</h2>
      <p>
        Door verschillende <nuxt-link to="/"> rijscholen </nuxt-link> met elkaar
        te vergelijken, kun je een welbewuste keuze maken voor de beste school
        in de regio om je rijbewijs DE te behalen. Je kunt kiezen voor de
        rijschool met het aantrekkelijkste uurtarief, maar ook informeren naar
        de opbouw van het traject dat moet leiden naar je rijbewijs en op basis
        daarvan je beslissing nemen. Hoe dan ook: het vergelijken van
        verschillende rijscholen kan geen kwaad. Integendeel. Sleep jouw
        rijbewijs DE binnen bij de rijschool waaraan je het beste gevoel
        overhoudt!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijbewijs DE halen? Vergelijk prijzen op Rijscholenvergelijker.nl!',
      headDescription:
        'Heb je je rijbewijs D al behaald, maar wil je graag in het bezit komen van het rijbewijs DE? Op Rijscholenvergelijker.nl vraag je gratis offertes aan!',
    }
  },
}
</script>
